module.exports = "https://cdn-skillquest.mathletics.com/app/195/assets/images/a42db4a90ab6149827c1a853f82925d7.svg";